// The job functions the search provider accepts for a person's current and
// past employer (current_employers.function_category and its past twin).
// Since Sep 29 it takes these 12 and nothing else: any other value matches no
// one, so the People Function picker, the saved personas, the legacy chat
// mapper and the MCP loader's vocabulary check all offer and accept exactly
// this list. Don't add a function the provider does not list.
//
// "Customer Success" stays our label; the API maps it to the provider's
// "Customer Success and Support".
//
// A vocab-sync test guards the backend's copy of this list.

export const LINKEDIN_FUNCTIONS = [
  'Engineering',
  'Sales',
  'Consulting',
  'Marketing',
  'Operations',
  'Finance',
  'Research',
  'Customer Success',
  'Arts and Design',
  'Human Resources',
  'Legal',
  'Product Management',
] as const;
